import { c as _c } from "react/compiler-runtime";
import Head from 'next/head';
import type { ReactNode } from 'react';
import { DemandTacticsBlock } from '@/components/demand/DemandTacticsBlock';
import { DemandGrid } from '@/components/demand/DemandGrid';
import { DemandConsumerJourneyBlock, DemandHeroBlock, DemandInspirationCtaBlock, DemandJourneyIntroBlock, DemandMakeItHappenBlock, DemandPillarsBlock } from '@/components/demand/blocks';

/**
 * The /demand page is composed from self-contained blocks laid out in a single
 * grid column. To reorder the page, move entries within the arrays below — no
 * per-section spacing to untangle.
 *
 * - `topBlocks` / `bottomBlocks` are full-bleed sections (hero, colour strips,
 *   CTAs) rendered edge-to-edge.
 * - `bodyBlocks` are the contained framework sections. They share one padded
 *   container and their vertical rhythm is controlled by the `gap` on
 *   <DemandGrid> below — change it once to respace the whole body.
 */
const topBlocks: ReactNode[] = [<DemandHeroBlock key="hero" />, <DemandPillarsBlock key="pillars" />];
const bodyBlocks: ReactNode[] = [<DemandJourneyIntroBlock key="journey-intro" />, <DemandConsumerJourneyBlock key="consumer-journey" />, <DemandTacticsBlock key="tactics" showStageBadges={false} />, <DemandMakeItHappenBlock key="make-it-happen" />];
const bottomBlocks: ReactNode[] = [<DemandInspirationCtaBlock key="inspiration-cta" />];
export default function DemandCentralPage() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Head><title>{"Demand Central | Create, Convert & Grow Demand | Sizzle"}</title><meta name="description" content="Learn how to create, convert and compound demand across the full customer journey, from awareness and intent to retention and advocacy." /></Head>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <>{t0}<main className="overflow-hidden bg-[#fffaf4] text-gray-950">{topBlocks}<section id="journey" className="scroll-mt-24 px-5 py-20 sm:px-8 sm:py-28 lg:px-12"><div className="mx-auto max-w-[1320px]"><DemandGrid gap="xl">{bodyBlocks}</DemandGrid></div></section>{bottomBlocks}</main></>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}